import { createContext } from 'react';

export const CurrentSongContext = createContext();


